import React, { Component } from "react";
import { Link } from "react-router-dom";
import Routes from "../constants/routes.json";
import Language from "../utils/Language";

import styles from "./Page404.module.css";

class Page404 extends Component {
  render() {
    return (
      <div className={styles.Wrap}>
        <div className={styles.Eyebrow}>
          {Language.GetString("404_eyebrow")}
        </div>
        <div className={styles.BigNumber}>404</div>
        <h1 className={styles.Title}>{Language.GetString("404_title")}</h1>
        <p className={styles.Subtitle}>{Language.GetString("404_subtitle")}</p>
        <Link to={Routes.home} className={styles.Cta}>
          {Language.GetString("404_cta")} →
        </Link>
      </div>
    );
  }
}

export default Page404;
